// The backend's login-hours refusal (auth_routes.check_login_time_restriction)
// is English: "Login restricted. Allowed hours: 08:00–17:00 (GMT+4) for group
// 'Name'". Shown in the user's language, with the hours and group it names;
// anything else the backend says is shown as it came.
const RESTRICTED = /^Login restricted\. Allowed hours: (.+?)–(.+?) \(GMT\+4\) for group '(.*)'$/;

export const loginRestrictionMessage = (message, t) => {
  const match = RESTRICTED.exec(String(message || ""));
  if (match) return t("auth.loginRestricted", { start: match[1], end: match[2], group: match[3] });
  return message || t("auth.sessionEndedLoginHours");
};
